import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { ProcedimentoDTO } from "@app/shared/dto/procedimentoDTO";
import { ProcedimentoVO } from "@app/shared/vo/procedimentoVO";
import { Injectable } from "@angular/core";
import { MapperUtente } from "./mapper-utente";

@Injectable({
  providedIn: "root",
})
export class MapperProcedimento
  implements MapperInterface<ProcedimentoDTO, ProcedimentoVO> {
  constructor(private mapperUtente: MapperUtente) {}

  convertVoToDto(vo: ProcedimentoVO): ProcedimentoDTO {
    if (vo != null) {
      const dto = new ProcedimentoDTO();
      dto.codice = vo.codice;
      dto.nome = vo.nome;
      dto.responsabile = this.mapperUtente.convertVoToDto(vo.responsabile);
      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(dto: ProcedimentoDTO): ProcedimentoVO {
    if (dto != null) {
      const vo = new ProcedimentoVO();
      vo.codice = dto.codice;
      vo.nome = dto.nome;
      vo.responsabile = this.mapperUtente.convertDtoToVo(dto.responsabile);

      // TODO fare mapper questa riga funge solo se DTO e VO sono identici
      // vo = JSON.parse(JSON.stringify(dto));
      if (vo.nome != null && vo.nome.length > 40) {
        vo.output = vo.codice + " - " + vo.nome.substr(0, 40);
      } else {
        vo.output = vo.codice + " - " + vo.nome;
      }
      return vo;
    } else {
      return null;
    }
  }

  convertListVoToDto(voList: ProcedimentoVO[]): ProcedimentoDTO[] {
    if (voList != null) {
      return voList.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }

  convertListDtoToVo(dtoList: ProcedimentoDTO[]): ProcedimentoVO[] {
    if (dtoList != null) {
      return dtoList.map((dto) => this.convertDtoToVo(dto));
    } else {
      return null;
    }
  }
}
